// "Mailing address" section on the Profile tab (behind login). Same row as the
// /gift/:token page, via GET/PUT /profile/shippingAddress in puttr-api.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants/Strings';
import { getToken } from '../common/GetToken';
import AddressForm from './AddressForm';
import { AddressCard } from './GiftAddress';
import './GiftAddress.css';

export default function ShippingAddressCard({ profile }) {
  const [state, setState] = useState({ loading: true, address: null, status: null, confirmedAt: null });
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const tok = await getToken();
        const res = await axios.get(API_URL + '/profile/shippingAddress', { headers: { Authorization: `Bearer ${tok}` } });
        if (alive) setState({ loading: false, ...res.data });
      } catch (e) {
        if (alive) { setState(s => ({ ...s, loading: false })); setError('Could not load your mailing address.'); }
      }
    })();
    return () => { alive = false; };
  }, []);

  const save = async (address) => {
    const tok = await getToken();
    const res = await axios.put(API_URL + '/profile/shippingAddress', address, { headers: { Authorization: `Bearer ${tok}` } });
    setState({ loading: false, ...res.data });
    setEditing(false);
  };

  const defaults = {
    shipName: profile ? [profile.firstName, profile.lastName].filter(Boolean).join(' ') : '',
    country: 'US',
  };

  return (
    <div className="shipCard">
      <h4 style={{ marginTop: 20 }}>MAILING ADDRESS</h4>
      <div className="shipMuted" style={{ marginBottom: 10 }}>Where Puttr sends anything physical: Club gifts, prizes, replacement parts.</div>
      {state.loading ? <div className="shipMuted">Loading…</div> : null}
      {error ? <div className="addrFormError">{error}</div> : null}
      {!state.loading && !editing && state.address ? (
        <>
          <AddressCard address={state.address} className="addrCardLight" />
          <div className="giftActions">
            <button className="giftLink" onClick={() => setEditing(true)}>Edit address</button>
          </div>
        </>
      ) : null}
      {!state.loading && !editing && !state.address ? (
        <div className="giftActions">
          <div className="shipMuted">No mailing address on file.</div>
          <button className="btnGhost" onClick={() => setEditing(true)}>Add mailing address</button>
        </div>
      ) : null}
      {editing ? (
        <AddressForm
          initial={state.address}
          defaults={defaults}
          onSave={save}
          onCancel={() => setEditing(false)}
          submitLabel="Save address"
        />
      ) : null}
    </div>
  );
}
